import styled from 'styled-components';
import { Plan } from './plans';

export const Card = styled.div`
  border: 1px solid var(--border-light);
  border-radius: 4px;
  background-color: var(--surface-elevated);
  padding: 0;
  font-family: sans-serif;
  position: relative;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Header = styled.div<{ colorScheme?: Plan['colorScheme'] }>`
  background-color: ${(props) =>
    props.colorScheme === 'blue' && 'var(--mid-blue)'};
  background-color: ${(props) =>
    props.colorScheme === 'lightBlue' && 'var(--background)'};
  background-color: ${(props) =>
    props.colorScheme === 'black' && 'var(--dark-blue)'};

  color: ${(props) => props.colorScheme === 'blue' && '#fff'};
  color: ${(props) => props.colorScheme === 'lightBlue' && 'var(--text)'};
  color: ${(props) => props.colorScheme === 'black' && '#fff'};
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  padding: 1rem 4rem;
  border-radius: 4px 4px 0 0;
  margin: 0 0 0.5rem 0;
`;

export const Price = styled.div`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 4px;
  color: var(--text);
`;

export const DiscountText = styled.p`
  color: #068051;
  font-weight: 600;
  font-size: 14px;
  margin: 0;
`;

export const Period = styled.span`
  font-size: 14px;
  font-weight: normal;
`;

export const Description = styled.p`
  font-size: 14px;
  color: var(--text-muted);
  text-align: left;
  margin: 12px 0 20px;
  padding: 0 0.5rem;
`;

export const FeatureRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.25rem 0.5rem;
  color: var(--text-muted);
  font-size: 14px;
  text-align: left;

  &:first-of-type {
    border-top: none;
  }
`;

export const FeatureValue = styled.span`
  white-space: nowrap;
  flex-shrink: 0;
`;

export const Cross = styled.span`
  color: var(--border-dark);
`;

export const Dots = styled.div`
  flex: 1;
  border-bottom: 1px dotted var(--border-dark);
  height: 1px;
  margin-top: 12px;
  margin-left: 16px;
  margin-right: 16px;
`;

export const SubscriptionFooter = styled.div`
  font-size: 12px;
  text-align: left;
  margin-top: 16px;
  padding: 0.25rem 0.5rem;
  color: var(--text-muted);
`;

export const BadgeContainer = styled.div`
  position: absolute;
  top: 48px;
  right: 16px;
`;
export const InputContainer = styled.div`
  background-color: var(--surface-elevated);
  width: fit-content;
  margin: 0 auto 16px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid var(--border);

  & label {
    cursor: pointer;
  }

  input[type='radio'] {
    accent-color: var(--active-blue);
  }
`;
